export default __webpack_public_path__ + "components/weather-icon/static/daymodrain@2-cd4c3c4fc0549889da6c799ecdbccf64.png";